// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button {\n    color: #7bd812 !important;\n    background: #ffff !important;\n    border: 2px solid #e7e7e7;\n}\n.language-content {\n    float: left;\n    color: #b6b6b6 !important;\n\n}\n.language-content a{\n    color:#b6b6b6 !important\n\n}\n.language-content a:hover {\n    border-bottom-color: #7bd812 !important;\n}\n.language-content .active {\n    color: #7bd812 !important;\n}\n", ""]);
// Exports
module.exports = exports;
